// 'en_US' => 'en'
export default locale => (locale ? locale.substring(0, locale.indexOf('_')) : '');
